import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { authFetch } from '../common/authFetch';
import { useVocabulary } from '../contexts/VocabularyContext';

const API_URL = process.env.REACT_APP_BACKEND_URL;

/**
 * 단어 학습 페이지 공용 탭.
 * 사이드바 항목을 늘리지 않고 관련 화면을 한 곳에 묶는다.
 */
export const VocabularyTabs = ({ active }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();

  const tabs = [
    { key: 'words', path: '/vocabulary', label: t('vocabulary.tabWords') },
    { key: 'wordbook', path: '/vocabulary/wordbook', label: t('vocabulary.tabWordbook') },
    { key: 'quiz', path: '/vocabulary/quiz', label: t('vocabulary.tabQuiz') },
    { key: 'review', path: '/vocabulary/review', label: t('vocabulary.tabReview') },
  ];

  return (
    <nav className="vocab-tabs">
      {tabs.map(tab => (
        <button
          key={tab.key}
          className={`vocab-tab${(active || location.pathname) === (active ? tab.key : tab.path) ? ' active' : ''}`}
          onClick={() => navigate(tab.path)}
        >
          {tab.label}
        </button>
      ))}
    </nav>
  );
};

/**
 * 관찰 대상 학생 선택.
 * 관찰자가 아니면 아무것도 렌더하지 않는다.
 *
 * 선택은 VocabularyContext에 보관한다 — 화면마다 따로 들고 있으면
 * 시험 → 응시/시험지로 넘어갈 때 선택이 사라져 남의 시험을 열 수 없다.
 */
export const StudentSelector = () => {
  const { t } = useTranslation();
  const { studentId, setStudentId } = useVocabulary();
  const [students, setStudents] = useState([]);

  useEffect(() => {
    const load = async () => {
      try {
        const res = await authFetch(`${API_URL}/api/v1/observer/students`);
        const data = await res.json();
        if (data.success) {
          setStudents((data.students || []).filter(s => s.perm_vocabulary));
        }
      } catch (e) {
        console.error('Failed to fetch students', e);
      }
    };
    load();
  }, []);

  if (students.length === 0) return null;

  return (
    <select className="vocab-select" value={studentId} onChange={(e) => setStudentId(e.target.value)}>
      <option value="">{t('vocabulary.myVocabulary')}</option>
      {students.map(s => (
        <option key={s.user_id} value={s.user_id}>{s.username}</option>
      ))}
    </select>
  );
};

export default VocabularyTabs;
